









import Vue from 'vue'
import CustomMultiselect from '@/UI/Shared/CustomMultiselect.vue'
import { TranslateResult } from 'vue-i18n'

interface ProvinceOption {
  id: number;
  label: TranslateResult;
}

export default Vue.extend({
  name: 'ProvinceSelector',
  components: {
    CustomMultiselect
  },
  props: {
    id: {
      type: String,
      default: 'campo-select'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentOption: ''
    }
  },
  watch: {
    value (newValue: string) {
      this.currentOption = newValue
    }
  },
  created () {
    this.currentOption = this.value
  },
  computed: {
    options (): ProvinceOption[] {
      const options = [
        { id: 0, label: '-' },
        { id: 15, label: this.$t('provincias.15') },
        { id: 27, label: this.$t('provincias.27') },
        { id: 32, label: this.$t('provincias.32') },
        { id: 36, label: this.$t('provincias.36') }
      ]
      return options.sort((a, b) => {
        return a.label.toString().localeCompare(b.label.toString())
      })
    }
  }
})
